// extracted by mini-css-extract-plugin
export default {"FullPageLoader":"FullPageLoader_FullPageLoader__ffjNj","LoaderRing":"FullPageLoader_LoaderRing__8ymgp","LoaderRingFrames":"FullPageLoader_LoaderRingFrames__5sda9"};